import React, { ReactNode } from 'react'
import * as styles from './Popup.module.scss'
import CrossIcon from './assets/cross.svg'

interface PopupProps {
  onClose?(): void
  children: ReactNode
  showCross?: boolean
}
const Popup: React.FC<PopupProps> = ({ onClose, children, showCross = true }: PopupProps) => {
  function handleClose (e: React.MouseEvent) {
    if (onClose != null) {
      onClose()
      e.preventDefault()
    }
  }

  return (
    <div className={styles.container}>
      <div
        className={styles.overlay}
        onClick={e => handleClose(e)}
      />
      <div className={styles.modal}>
        {showCross && (
          <CrossIcon
            className={styles.cross}
            onClick={(e: React.MouseEvent) => handleClose(e)}
          />
        )}
        {children}
      </div>
    </div>
  )
}

export default Popup
